<template>
	<div class="presentation-row">
		<div class="presentation-row card between-md middle-md" v-bind:class="{ isSection: presentation.isSection }" >
			<div class="row">
				<div class="col-md-4">
					<h3>{{presentation.title}}</h3><br>
					<span v-if="presentation.isSection">Szekció</span><span v-else>Előadás</span><br>
					{{formatedDate(presentation.fromDate)}} - {{formatedDate(presentation.toDate)}}<br>
					<span v-if="!presentation.isSection">{{formatedTime(presentation.fromDate)}} - {{formatedTime(presentation.toDate)}}</span>
				</div>
				<div v-if="presentation.isSection" class="col-md-8 end-md">
					<md-button v-if="presentation.isSection" v-on:click.native="create(presentation.fireId, false)">Előadás hozzadása</md-button>
					<md-button v-if="presentation.isSection" v-on:click.native="create(presentation.fireId, true)">Alszekció hozzadása</md-button>
					<md-button v-if="presentation.isSection" v-on:click.native="switchOpen()">{{ open ? "Bezárás" : "Megnyitás" }}</md-button>
				</div>
				<div class="col-md-8">
					<div v-if="presentation.ratingCount > 0" class="ratings col-md-12">
						Összes értékelés: <b>{{presentation.ratingCount}}</b> - 
						Átlagos értékelés: <b>{{presentation.ratingAvg}} / 6</b>
					</div>
					<div v-if="Object.keys(presentation.comments).length > 0" class="comment col-md-12">
						Hozzászólások:
						<p v-for="(comment, userId) in presentation.comments">
							{{comment}}
						</p>
					</div>
				</div>
			</div>
			<div class="row end-md">
				<md-button class="md-warn" v-on:click.native="remove(presentation)">Törlés</md-button>
				<md-button class="md-primary" v-on:click.native="edit(presentation)">Szerkesztés</md-button>

			</div>
		</div>
		<div class="subsections card" v-if="open">
			<div v-for="presentation in presentation.presentations">
				<presentation-row :presentation="presentation" :depth="(depth + 1)"></presentation-row>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import FirebaseDBService from '../../services/FirebaseDBService'
	import moment from 'moment'
	import _ from 'lodash'

	export default {
		name: "presentation-row",
		props: {
			presentation: Object,
			depth: 0,
			open: false
		},
		methods: {
			switchOpen: function(){
				this.open = !this.open;
				let openSections = JSON.parse(Vue.localStorage.get('openSections', '{}'));
				openSections[this.presentation.fireId] = !openSections[this.presentation.fireId];
				Vue.localStorage.set('openSections', JSON.stringify(openSections));
			},
			formatedDate: function(date){
				return moment(date).format("YYYY MMMM DD.")
			},
			formatedTime: function(date){
				return moment(date).format("HH:mm")
			},
			edit: function(presentation){
				this.$router.push({ name: 'admin-editor', query: { type: 'presentation', id: presentation.fireId, isSection: presentation.isSection }});
			},
			create(parent, isSection){
				this.$router.push({ name: 'admin-editor', query: { type: 'presentation', parentSection: parent, isSection: isSection }});
			},
			remove: function(presentation){
				FirebaseDBService.deletePresentation(presentation);
				//this.loadData();
			}
		},
		mounted(){
			let openSections = JSON.parse(Vue.localStorage.get('openSections', '{}'));
			if(openSections[this.presentation.fireId]){
				this.open = true;
			}
		}
	}
</script>

<style scoped>
	h1, h2 {
		font-weight: normal;
	}

	h3 {
		margin: 0;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #F0AA57;
	}

	.details{
		font-size: 12pt;
	}

	.comment p {	
		margin-bottom: 2px;
		padding: 4px;
		background-color: #eee;
	}

	.isSection{
		background-color: rgb(157, 230, 255);
	}

	.subsections{
		background-color: rgba(0,0,0,0.3);
		margin-top: -16px;
	}
</style>



// WEBPACK FOOTER //
// PresentationRow.vue?d9697dce